import { put, take, select } from "redux-saga/effects"
import fixSagaError from "src/helpers/fixSagaError"
import { request, refreshToken, logout } from "../actions/creators"
import {
  requestsLocked as selectRequestsLocked,
  request as selectRequest,
} from "../selectors"
import { REQUEST_SUCCESS, REQUEST_ERROR } from "../actions/types"

/* The trick is that request must return generator's result, so we need
   a separated generator */
function* requestGenerator(url, query, opt) {
  /* Action can be changed while handling response */
  let action = request({
    url,
    query,
    options: opt,
  })

  /* Prevent to making same requests at the same time */
  if (opt.dedup) {
    const existenAction = yield select(selectRequest, action)

    if (existenAction) {
      action = existenAction
    } else {
      yield put(action)
    }
  } else {
    yield put(action)
  }

  while (true) {
    /* Await for response
     * Exactly for REQUEST_SUCCESS, REQUEST_ERROR actions
     * */
    const reaction = yield take([REQUEST_SUCCESS, REQUEST_ERROR])

    /* Filter response only created by our action
     *
     * The response must contain origin action to identify it.
     *  */
    if (reaction.action === action) {
      /* Before handle response, we should check lock status
       *
       * Lock is a state value, which means that in some reason making requests
       * is disabled for now
       * */
      const locked = yield select(selectRequestsLocked)
      if (locked) {
        /* If requests are disabled, we must  re-create request, thereby that
         * request will be locked until requests to be unlocked, but continue
         * its work after unlocking */
        action = request({
          url,
          query,
          options: opt,
        })
        yield put(action)

        /* After re-creation await cycle must be refreshed */
      } else {
        if (reaction.type === REQUEST_SUCCESS) {
          /* Successful requests must be immediately returned */
          return reaction.response
        }

        /* Failed request must be handled */
        const { error } = reaction

        if (error.response) {
          switch (error.response.status) {
            /* Unauthorized */
            case 401:
              switch (error.data.errorCode) {
                case `authentication.token.expired`:
                  /* Perhaps request token is out of date */
                  yield put(refreshToken())
                  /* After staring refreshing, we must re-create request */
                  action = request({
                    url,
                    query,
                    options: opt,
                  })
                  yield put(action)
                  break
                default:
                  /* Cancel all request, redirect to the login page */
                  return put(logout())
              }
              break
            default: {
              throw fixSagaError(error)
            }
          }
        } else {
          throw fixSagaError(error)
        }
      }
    }
  }
}

export default function requestEffect(url, query = {}, opt = {}) {
  return requestGenerator(url, query, opt)
}
